var MixMatchText = (function($) {

  var _s = {
    container: $('.chm-block-mix-match-text'),
    text_options_container: $('.chm-block-mix-match-text .text-options'),
    text_options_container1: $('.chm-block-mix-match-text .text-options-1'),
    text_options_container2: $('.chm-block-mix-match-text .text-options-2'),
    text_options: $('.chm-block-mix-match-text .text-options > span'),
  };

  var _init = function() {
    _bindEvents();
  };

  var _bindEvents = function() {

    $.each([_s.text_options_container1, _s.text_options_container2], function(i, val) {
      let interval = (i == 0) ? 4300 : 7000;
      setInterval(function() {
        let currentActive = val.find('.active');
        let nextActive = (currentActive.next().length > 0) ? currentActive.next() : val.children(':first');
  
        currentActive.removeClass('active');
        nextActive.addClass('active');
      }, interval);
    });

  };

  return {
    init: _init
  };

})(jQuery);